<template>
  <div class="TestKitSpread" :class="judgeName">
    <div class="TestKitSpread-content">
      <div class="button">
        <mu-button :class="[judgeName + 'Button']" @click="link"
          >领取登记</mu-button
        >
        <mu-button :class="[judgeName + 'Button']" @click="See"
          >结果查询</mu-button
        >
      </div>
      <span>天津市大肠癌筛查优化项目</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestKitSpread',
  data() {
    return {
      sort: null,
      inviter: null,
    }
  },
  computed: {
    judgeName() {
      let sort = this.sort
      return sort == 'taxi'
        ? ' taxi'
        : sort == 'shi'
        ? 'shi'
        : sort == 'fit'
        ? 'fit'
        : 'intestines'
    },
  },
  created() {
    let index = this.$route.query.state.indexOf('|')
    if (index > 0) {
      let indexs = index + 1
      this.sort = this.$route.query.state.substring(0, indexs - 1)
      this.inviter = this.$route.query.state.substring(indexs)
    } else {
      this.sort = this.$route.query.state
    }
  },
  methods: {
    link() {
      this.sort == 'shi'
        ? this.$router.push({
            // path: '/TestKitCommitment',
            path: '/TestKitInfo',
            query: {
              state: this.sort,
              inviter: this.inviter,
            },
          })
        : this.$router.push({
            path: '/TestKitInfo',
            query: {
              state: this.sort,
              inviter: this.inviter,
            },
          })
    },
    See() {
      this.$router.push({
        path: '/TestKitSeeResult',
        query: {
          state: this.sort,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../style/TestKit/TestKitSpread';
</style>
